import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import moment from 'moment-timezone';

import { Status } from '../../classess/status/status';
import {
    getProcessButtons, charactersRemainingGet, setDateTimeFormatGlobalString, isUndNullEmp, isValidDate, getLanguageObj,
    getResponse, getRolesType, settings, styles,
    handleResponseMessageAsync
} from '../../helpers/main';
import { SystemAccessService } from '../../services/systemAccesses/SystemAccessService';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { SystemAccessDetail } from '../../classess/systemAccess/systemAccessDetail';
import { User } from '../../classess/user/user';

const { icons, images, labels, messages } = settings;

const currentMethod = 'SystemAccessDetailAddEditDetail';

export default function SystemAccessDetailAddEditDetail({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtSystemAccessesDetailsId: '',
        dtSystemAccessesDetailsRowId: 0,
        systemAccessDetail: SystemAccessDetail?.class({}, false),
        sadFieldViews: {
            register: {
                date: '',
                time: '',
            },
            analyst: {
                model: User?.getClass({}, false),
                html: ''
            },
            commentary: '',
            userRegister: {
                model: User?.getClass({}, false),
                html: ''
            },
            userRegisterDate: {
                date: '',
                time: '',
            },
        },
        analysts: [User?.getClass({}, false)],
        adminAnalysts: [User?.getClass({}, false)],
        status: [Status?.getClass({}, false)],
        userRoles: getRolesType(),
        viewParams: { type: 0, id: 0, },
    },
    setModalObj = {},
}) {
    //#region variables
    const isMount = useRef(false);
    const inpUserRegisterDateRef = useRef(null);
    const txtAreaCommentaryRef = useRef(null);

    const [process, setProcess] = useState({
        save: false,
    });

    const [errors, setErrors] = useState({
        userRegisterDate: '',
        analyst: '',
        informCreationUser: '',
        commentary: '',
    });

    const [dataFormLength] = useState(SystemAccessDetail.minMaxLength(false));
    const [modalCharactersRemaining, setModalCharactersRemaining] = useState('');

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalSave',
            },
            closeModal: {
                defaultClass: 'close border-0 bg-transparent',
                id: 'btnModalClose',
            },
        },
        icons: {
            save: {
                id: 'iconModalSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            userRegisterDate: {
                id: 'inputModalUserRegisterDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
            },
        },
        pickers: {
            userRegisterDate: {
                id: 'pkModalUserRegisterDate',
            },
        },
        selects: {
            analyst: {
                id: 'selModalAnalyst',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            informCreationUser: {
                id: 'selModalInformCreationUserId',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
        },
        spiners: {
            save: {
                id: 'spModalSave',
                defaultClass: '',
            }
        },
        textAreas: {
            commentary: {
                id: 'txtAreaModalCommentary',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
        },
    };
    //#endregion variables

    //#region methods
    //#region systemaccessdetail
    const addSystemAccessDetail = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'addSystemAccessDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            const systemAccessDetailSetData = response?.result?.systemAccessDetail || modalObj?.systemAccessDetail;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, save: true }));

            response = await SystemAccessService.createDetail({
                auth: modalObj?.auth,
                systemAccessDetail: systemAccessDetailSetData,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            setModalObj(prev => ({
                ...prev,
                systemAccessDetail: response?.result?.systemAccessDetail || {}
            }));

            response = dataTablesAddUpdateDelete({
                processType: 0,
                systemAccessDetail: response?.result?.systemAccessDetail || modalObj?.systemAccessDetail,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false }));
            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    const editSystemAccessDetail = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editSystemAccessDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            const systemAccessDetailSetData = response?.result?.systemAccessDetail || modalObj?.systemAccessDetail;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, save: true }));

            response = await SystemAccessService.updateDetail({
                auth: modalObj?.auth,
                systemAccessDetail: systemAccessDetailSetData,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            setModalObj(prev => ({
                ...prev,
                systemAccessDetail: response?.result?.systemAccessDetail || {}
            }));

            response = dataTablesAddUpdateDelete({
                processType: 1,
                systemAccessDetail: response?.result?.systemAccessDetail || modalObj?.systemAccessDetail,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false }));
            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }
    //#endregion systemaccessdetail

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            response = setDateInControl({
                _date: new Date().toISOString(),
                _userRegisterDate: modalObj?.systemAccessDetail?.userRegisterDate,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            if (modalObj?.type === 0 && modalObj?.userRoles?.isAnalyst) {
                setModalObj(prev => ({
                    ...prev,
                    systemAccessDetail: {
                        ...prev?.systemAccessDetail,
                        analystId: modalObj?.auth?.user?.id,
                        informCreationUserId: modalObj?.auth?.user?.id,
                    },
                }));
            }

            setModalCharactersRemaining(
                charactersRemainingGet({
                    text: modalObj?.systemAccessDetail?.commentary,
                    maxLength: dataFormLength?.max?.commentary,
                    msgText: `${messages?.charactersRemaining?.[modalObj?.languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    systemAccessDetail: SystemAccessDetail?.class({}, false),
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(`Method: ${currentMethod}, Sub method: ${subMethod}, Error: ${ex?.message}`);
        }
        return response;
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            const userRegisterDate = modalObj?.$(`#${controls?.inputs?.userRegisterDate?.id}`).val();
            const commentaryStr = txtAreaCommentaryRef.current?.value || '';
            const errors_ = {
                userRegisterDate: '',
                analyst: '',
                commentary: ''
            };

            const thisFieldIsRequired = `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`;

            if (isUndNullEmp({ data: userRegisterDate, subMethod: currentMethod })?.result || !isValidDate({ data: userRegisterDate, subMethod: currentMethod })?.result) {
                errors_.userRegisterDate = thisFieldIsRequired;
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmp({ data: modalObj?.systemAccessDetail?.analystId, subMethod: currentMethod })?.result) {
                errors_.analyst = thisFieldIsRequired;
                response = getResponse({ type: 1 });
            }

            if (!commentaryStr) {
                errors_.commentary = thisFieldIsRequired;
                response = getResponse({ type: 1 });
            }

            if (response?.isWarning) {
                setErrors(prev => ({ ...prev, ...errors_ }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({
                ...prev,
                userRegisterDate: '',
                analyst: '',
                informCreationUser: '',
                commentary: '',
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setData';
        let response = getResponse({ type: 0 });
        try {
            const dateTimeFormat = `${modalObj?.languageObj?.format?.date?.f13}T${modalObj?.languageObj?.format?.time?.f2}.000Z`;
            const userRegisterDate = modalObj?.$(`#${controls?.pickers?.userRegisterDate?.id}`)?.datetimepicker('date')?._d;

            const systemAccessDetailSetData = {
                ...modalObj?.systemAccessDetail,
                userRegisterDate: moment(userRegisterDate)?.format(dateTimeFormat),
                registerDate: moment(new Date())?.format(dateTimeFormat),
                commentary: txtAreaCommentaryRef.current?.value || '',
            };

            setModalObj(prev => ({
                ...prev,
                systemAccessDetail: systemAccessDetailSetData
            }));

            response.result = { systemAccessDetail: systemAccessDetailSetData };
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDateInControl = ({
        _date = undefined,
        _userRegisterDate = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDateInControl';
        let response = getResponse({ type: 0 });
        try {
            let userRegisterDate = '';
            const tf = modalObj?.languageObj?.format?.time?.type;
            const dtf = `${modalObj?.languageObj?.format?.date?.f11} ${modalObj?.languageObj?.format?.time?.picker?.hhmm}`;
            const df = modalObj?.languageObj?.format?.date?.f1;

            if (!isUndNullEmp({ data: _userRegisterDate, subMethod: currentMethod })?.result) {
                userRegisterDate = setDateTimeFormatGlobalString({ date: _userRegisterDate, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: _date, subMethod: currentMethod })?.result) {
                userRegisterDate = setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            modalObj.$.fn.datetimepicker.Constructor.Default = modalObj?.$.extend({}, modalObj?.$.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: modalObj?.languageObj?.id }),
                locale: modalObj?.languageObj?.id,
            });

            modalObj?.$(`#${controls?.pickers?.userRegisterDate?.id}`)?.datetimepicker('options', {
                date: userRegisterDate,
                default: false,
                timepicker: true,
                format: dtf,
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const formDataSetAsync = async ({
        e = {},
        type = '',
        value = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'formDataSetAsync';
        let response = getResponse({ type: 0 });
        try {
            switch (type) {
                case 'commentary':
                    setModalObj(prev => ({
                        ...prev,
                        systemAccessDetail: {
                            ...prev?.systemAccessDetail,
                            [type]: value,
                        }
                    }));
                    setModalCharactersRemaining(
                        charactersRemainingGet({
                            text: value,
                            maxLength: dataFormLength?.max?.commentary,
                            msgText: `${messages?.charactersRemaining?.[modalObj?.languageObj?.id]}:`,
                            subMethod: `${currentMethod}`,
                        })?.result
                    );
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const dataTablesAddUpdateDelete = ({
        processType = 0,
        systemAccessDetail = SystemAccessDetail?.class({}, false),
        subMethod = '',
    } = {}) => {
        const currentMethod = 'dataTablesAddUpdateDelete';
        let response = getResponse({ type: 0 });
        try {
            let statusObj = {
                finalized: {
                    label: labels?.finalized?.en,
                    model: Status?.getClass({}, false),
                },
            };
            // let modelSystemAccessDetail = SystemAccessDetail.class(modalObj?.systemAccessDetail, false);
            let modelSystemAccessDetail = systemAccessDetail;
            let analystObj = {
                model: User?.getClass({}, false),
                label: '',
                labelHtml: '',
            };
            let registerDate = '';
            let registerTime = '';
            let processButtonObj = {
                description: ``,
                showEdit: false,
                showDelete: false,
            };
            let processButtons = [];

            statusObj = {
                ...statusObj,
                finalized: {
                    ...statusObj?.finalized,
                    model: modalObj?.status?.filter(({ name, label, }) => label === statusObj?.finalized?.label || name === statusObj?.finalized?.label)?.[0] || {},
                },
            };

            analystObj.model = modalObj?.analysts?.filter(({ id, }) => id === modelSystemAccessDetail?.analystId)?.[0] || {}
            analystObj.label = `${analystObj?.model?.firstName || ''} ${analystObj?.model?.lastName || ''}`;
            analystObj.labelHtml = analystObj?.label;
            registerDate = setDateTimeFormatGlobalString({
                date: modelSystemAccessDetail?.userRegisterDate,
                dateFormat: modalObj?.languageObj?.format?.date?.f1,
                timeFormat: 0,
                withSeconds: false,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            registerTime = setDateTimeFormatGlobalString({
                date: modelSystemAccessDetail?.userRegisterDate,
                dateFormat: '',
                timeFormat: modalObj?.languageObj?.format?.time?.type,
                withSeconds: false,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            processButtonObj = {
                description: `${registerDate} ${registerTime} - ${analystObj?.labelHtml}`,
                showEdit: ((modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst) && modalObj?.viewParams?.type === 1 && modelSystemAccessDetail?.statusId !== statusObj?.finalized?.model?.id),
                showDelete: ((modalObj?.userRoles?.isAdmin) && modalObj?.viewParams?.type === 1 && modelSystemAccessDetail?.statusId !== statusObj?.finalized?.model?.id),
            };

            switch (processType) {
                case 0:
                    modalObj?.$(`#${modalObj?.dtSystemAccessesDetailsId}`).DataTable().row.add([
                        modelSystemAccessDetail?.userRegisterDate,
                        registerDate || '',
                        registerTime || '',
                        analystObj?.labelHtml || '',
                        modelSystemAccessDetail?.commentary,
                        getProcessButtons({
                            id: modelSystemAccessDetail?.id,
                            description: processButtonObj?.description,
                            showDetails: true,
                            labelDetails: labels?.details?.[modalObj?.languageObj?.id],
                            enabledDetails: true,
                            showDelete: processButtonObj?.showDelete,
                            labelDelete: labels?.delete?.[modalObj?.languageObj?.id],
                            enabledDelete: processButtonObj?.showDelete,
                            showEdit: processButtonObj?.showEdit,
                            labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                            enabledEdit: processButtonObj?.showEdit,
                            processButtons: processButtons,
                        })?.result,
                    ])?.draw(true);
                    break;
                case 1:
                    modalObj?.$(`#${modalObj?.dtSystemAccessesDetailsId}`).DataTable().row(modalObj?.dtSystemAccessesDetailsRowId).data([
                        modelSystemAccessDetail?.userRegisterDate,
                        registerDate || '',
                        registerTime || '',
                        analystObj?.labelHtml || '',
                        modelSystemAccessDetail?.commentary,
                        getProcessButtons({
                            id: modelSystemAccessDetail?.id,
                            description: processButtonObj?.description,
                            showDetails: true,
                            labelDetails: labels?.details?.[modalObj?.languageObj?.id],
                            enabledDetails: true,
                            showDelete: processButtonObj?.showDelete,
                            labelDelete: labels?.delete?.[modalObj?.languageObj?.id],
                            enabledDelete: processButtonObj?.showDelete,
                            showEdit: processButtonObj?.showEdit,
                            labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                            enabledEdit: processButtonObj?.showEdit,
                            processButtons: processButtons,
                        })?.result,
                    ])?.draw(true);
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='systemAccess' src={images?.icons?.systemAccesses} style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.systemAccess?.[modalObj?.languageObj?.id]} ({labels?.details?.[modalObj?.languageObj?.id]?.toLowerCase()})</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`} style={settings?.html?.badges?.micro}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    device='button'
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: '', })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => modalObj?.type === 0 ?
                addSystemAccessDetail({ e: e, subMethod: 'form - onSubmit', }) :
                modalObj?.type === 1 ?
                    editSystemAccessDetail({ e: e, subMethod: 'form - onSubmit', }) :
                    e?.preventDefault()}>
                <Modal.Body className='p-0'>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ?
                            <div className='row'>
                                <div className='col-12 mb-3'
                                    hidden={!modalObj?.userRoles?.isAdmin}>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.date?.[modalObj?.languageObj?.id]}
                                        </small>
                                        {!isUndNullEmp({ data: modalObj?.systemAccessDetail?.userRegisterDate, subMethod: controls?.inputs?.userRegisterDate?.id, })?.result ?
                                            <div id={controls?.pickers?.userRegisterDate?.id}
                                                className='input-group date'
                                                data-target-input='nearest'>
                                                <input id={controls?.inputs?.userRegisterDate?.id}
                                                    ref={inpUserRegisterDateRef}
                                                    readOnly={process?.save}
                                                    className={controls?.inputs?.userRegisterDate?.defaultClass}
                                                    style={{ borderRadius: '5px' }}
                                                    data-target={`#${controls?.pickers?.userRegisterDate?.id}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setErrors(prev => ({ ...prev, userRegisterDate: '' }))}
                                                    placeholder={labels?.date?.[modalObj?.languageObj?.id]}
                                                    tooltip='tooltip'
                                                    title={labels?.date?.[modalObj?.languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append'
                                                    data-target={`#${controls?.pickers?.userRegisterDate?.id}`}
                                                    data-toggle='datetimepicker'>
                                                    <div className='input-group-text bg-secondary border-0'>
                                                        <i className={icons?.faFa?.calendarAlt} />
                                                    </div>
                                                </div>
                                            </div>
                                            : <div></div>}
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.userRegisterDate)}</div>
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-3'
                                    hidden={!modalObj?.userRoles?.isAdmin}>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.userTie} /> {labels?.analyst?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='input-group'>
                                            <select id={controls?.selects?.analyst?.id}
                                                disabled={(modalObj?.type !== 0 && modalObj?.type !== 1) || process?.save}
                                                className={controls?.selects?.analyst?.defaultClass}
                                                style={{ borderRadius: '5px' }}
                                                value={!isUndNullEmp({ data: modalObj?.systemAccessDetail?.analystId, subMethod: controls?.selects?.analyst?.id, })?.result ?
                                                    modalObj?.systemAccessDetail?.analystId : ``
                                                }
                                                onChange={(e) => setModalObj(prev => ({ ...prev, systemAccessDetail: { ...prev?.systemAccessDetail, analystId: e?.currentTarget?.value, } }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, analyst: '' }))}
                                                placeholder={labels?.analyst?.[modalObj?.languageObj?.id]}
                                                title={labels?.analyst?.[modalObj?.languageObj?.id]}>
                                                <option key={`nothing`} value={``}>{messages?.selectAnalyst?.[modalObj?.languageObj?.id]}</option>
                                                {modalObj?.analysts?.map((analyst) =>
                                                    <option key={analyst?.id} value={analyst?.id}>{`${analyst?.firstName || ''} ${analyst?.lastName || ''} - ${analyst?.department || ''}`}</option>)
                                                }
                                            </select>
                                        </div>
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.analyst)}</div>
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-3'
                                    hidden={!modalObj?.userRoles?.isAdmin}>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.user} /> {labels?.user?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='input-group'>
                                            <select id={controls?.selects?.informCreationUser?.id}
                                                disabled={(modalObj?.type !== 0 && modalObj?.type !== 1) || process?.save}
                                                className={controls?.selects?.informCreationUser?.defaultClass}
                                                style={{ borderRadius: '5px' }}
                                                value={!isUndNullEmp({ data: modalObj?.systemAccessDetail?.informCreationUserId, subMethod: controls?.selects?.informCreationUser?.id, })?.result ?
                                                    modalObj?.systemAccessDetail?.informCreationUserId : ``
                                                }
                                                onChange={(e) => setModalObj(prev => ({ ...prev, systemAccessDetail: { ...prev?.systemAccessDetail, informCreationUserId: e?.currentTarget?.value, } }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, informCreationUser: '' }))}
                                                placeholder={labels?.user?.[modalObj?.languageObj?.id]}
                                                title={labels?.user?.[modalObj?.languageObj?.id]}>
                                                <option key={`nothing`} value={``}>{messages?.selectUser?.[modalObj?.languageObj?.id]}</option>
                                                {modalObj?.adminAnalysts?.map((user) =>
                                                    <option key={user?.id} value={user?.id}>{`${user?.firstName || ''} ${user?.lastName || ''} - ${user?.department || ''}`}</option>)
                                                }
                                            </select>
                                        </div>
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.informCreationUser)}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-0'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.edit} /> {labels?.commentary?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <textarea id={controls?.textAreas?.commentary?.id}
                                            ref={txtAreaCommentaryRef}
                                            readOnly={process?.save}
                                            className={controls?.textAreas?.commentary?.defaultClass}
                                            style={{ minHeight: '100px', borderRadius: '5px' }}
                                            maxLength={dataFormLength?.max?.commentary}
                                            placeholder={labels?.commentary?.[modalObj?.languageObj?.id]}
                                            onChange={(e) => formDataSetAsync({ e: e, type: 'commentary', value: e?.target?.value, subMethod: controls?.textAreas?.commentary?.id })}
                                            onFocus={() => setErrors(prev => ({ ...prev, commentary: '' }))}
                                            rows={2}
                                            value={!isUndNullEmp({ data: modalObj?.systemAccessDetail?.commentary, subMethod: controls?.textAreas?.commentary?.id })?.result ?
                                                modalObj?.systemAccessDetail?.commentary : ''}
                                            tooltip='tooltip'
                                            title={labels?.commentary?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text' style={styles?.labelMsgInfo}>{parse(modalCharactersRemaining)}</div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{parse(errors?.commentary)}</div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-12 col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.date?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>{modalObj?.sadFieldViews?.userRegisterDate?.date}</span>
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.clock} /> {labels?.time?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>{modalObj?.sadFieldViews?.userRegisterDate?.time}</span>
                                    </div>
                                </div>
                                <div className='col-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.userTie} /> {labels?.analyst?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold'>
                                            {modalObj?.sadFieldViews?.analyst?.html}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 mb-4'>
                                    <small className='text-muted text-uppercase font-weight-bold d-block mb-2' style={settings?.html?.labels?.detailMicro}>
                                        <i className={icons?.fasFa?.edit} /> {labels?.commentary?.[modalObj?.languageObj?.id]}
                                    </small>
                                    <div className='p-3 rounded bg-white border-left border-secondary shadow-sm' style={{ minHeight: '100px', fontSize: '0.95rem', lineHeight: '1.6', overflowWrap: 'break-word' }}>
                                        {modalObj?.sadFieldViews?.commentary || '---'}
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-success shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.registerDate?.[modalObj?.languageObj?.id] || labels?.date?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>{modalObj?.sadFieldViews?.register?.date}</span>
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-success shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.clock} /> {labels?.time?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>{modalObj?.sadFieldViews?.register?.time}</span>
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className='p-3 rounded bg-light border-left border-success shadow-sm' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.user} /> {labels?.user?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold'>
                                            {modalObj?.sadFieldViews?.userRegister?.html}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            hidden={modalObj?.type === 2}
                            tooltip='tooltip'
                            title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                            type='submit'>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i id={controls?.icons?.save?.id} className={icons?.fasFa?.save} />
                            )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            tooltip='tooltip'
                            title={labels?.close?.[modalObj?.languageObj?.id]}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i id={controls?.icons?.back?.id} className={icons?.fasFa?.arrowCircleLeft}></i> {labels?.back?.[modalObj?.languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}